<template>
  <div v-if="contact.length" class="d-flex flex-column contact-widget">
    <div
      v-for="({ link, icon, target, size, text }, i) in contact"
      :key="i"
      class="mb-2 mb-md-0"
    >
      <v-btn :href="link" :target="target" class="text-none" text>
        <v-icon color="primary" :size="size" left>
          {{ icon }}
        </v-icon>
        <span>{{ text }}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { getContact } from "../../utils/getContact";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contact() {
      return getContact(this.informations);
    },
  },
};
</script>

<style lang="scss">
.contact-widget {
  width: max-content;
  max-width: 100%;

  .v-btn__content {
    max-width: 100%;
    white-space: normal;
  }
}
</style>
